import React from "react";
import { Link, useParams } from "react-router-dom";
import { MdLocationPin } from "react-icons/md";
import {
  administrativeData,
  apartmentsData,
  commercialData,
  // hotelApartmentsData,
  medicalData,
  newupcomingdata,
  pharmaciesData,
  villaData,
} from "../data/data";
import HeroSection from "../components/heroSection/HeroSection";
import Container from "../components/Container";
import Button from "../components/Button";
import { Helmet } from "react-helmet";
import SahabaVillas from "./SahabaVillas";

import villa from "../Assets/villa.jpg";
import apartment from "../Assets/Apartment.jpg";
// import hotelApartment from "../Assets/hotel-apartment.jpg";
import administrative from "../Assets/administrative.jpg";
import commercial from "../Assets/alhana_center_2.webp";
import pharmacies from "../Assets/woman-working-pharmacy-wearing-coat.jpg";
import newCairo from "../Assets/new-cairo-city.jpg";

function Single() {
  const { id } = useParams();
  let data, image;

  switch (id) {
    case "villa":
      data = villaData;
      image = villa;
      break;
    case "apartment":
      data = apartmentsData;
      image = apartment;
      break;
    // case "hotelApartment":
    //   data = hotelApartmentsData;
    //   image = hotelApartment;
      // break;
    case "commercial":
      data = commercialData;
      image = commercial;
      break;
    case "administrative":
      data = administrativeData;
      image = administrative;
      break;
    case "medical":
      data = medicalData;
      image = commercial;
      break;
    case "pharmacies":
      data = pharmaciesData;
      image = pharmacies;
      break;
    case "Upcoming Projects":
      data = newupcomingdata;
      image = newCairo;
      break;
    default:
      data = null;
      image = "";
      break;
  }

  // Dynamic meta description based on property type
  const metaDescription = data && data[0] && data[0].title
    ? `Details and listings for ${id} properties in Dubai. Find your ideal ${id} with Al Ghaith Properties.`
    : "Browse premium properties in Dubai with Al Ghaith Properties.";

  // Removed the bypass to allow the default grid to render for all projects

  return (
    <div data-aos="zoom-in">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{id ? `${id.charAt(0).toUpperCase() + id.slice(1)} | Al Ghaith Properties` : 'Property | Al Ghaith Properties'}</title>
        <meta name="description" content={metaDescription} />
        <link rel="canonical" href={`https://www.al-ghaith.ae/projects/${id || ''}`} />
      </Helmet>
      <HeroSection page={`Projects > ${id}`} image={image} />
      <Container>
        {data ? (
          <div
            className="relative top-[-100px] text-white grid sm:grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-[20px]
          grid-cols-[repeat(auto-fill,minmax(200px,1fr))]">
            {data.map((el) => {
              return (
                <div
                  data-aos="fade-up"
                  data-aos-duration="3000"
                  key={el.id}
                  className="relative mx-auto bg-[#2b4a94] transition-all">
                  {el.link ? (
                    <Link to={el.link} className="block group">
                      <img
                        src={el.image}
                        alt={el.title ? `Photo of ${el.title}` : 'Property image'}
                        className="w-[300px] h-[330px] object-cover group-hover:scale-[1.02] transition-transform"
                        loading="lazy"
                        width={300}
                        height={330}
                        aria-label={el.title ? `Photo of ${el.title}` : 'Property image'}
                      />
                      <div className="p-[20px] ">
                        <h2 className="sm:text-xl font-bold py-[10px]">
                          {el.title}
                        </h2>
                        <div className="py-[10px] text-xs flex items-center gap-[10px] justify-between border-t border-gray">
                          <p className="underline underline-offset-2">View Property</p>
                        </div>
                      </div>
                    </Link>
                  ) : (
                    <>
                      <img
                        src={el.image}
                        alt={el.title ? `Photo of ${el.title}` : 'Property image'}
                        className="w-[300px] h-[330px] object-cover"
                        loading="lazy"
                        width={300}
                        height={330}
                        aria-label={el.title ? `Photo of ${el.title}` : 'Property image'}
                      />
                      <div className="p-[20px] ">
                        <h2 className="sm:text-xl font-bold py-[10px]">
                          {el.title}
                        </h2>

                        <div className="py-[10px] text-xs flex items-center gap-[10px] justify-between border-t border-gray">
                          <p>
                            <a href={el.location} aria-label={el.title ? `View location of ${el.title}` : 'View property location'} target="_blank" rel="noopener noreferrer">
                              <MdLocationPin size="26px" color="white" aria-hidden="true" />
                            </a>
                          </p>
                          <p aria-label={el.Installment ? `${el.Installment} units available` : undefined}>{el.Installment} Units</p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-white p-[20px] text-center flex items-center justify-center flex-col gap-[20px]" role="alert" aria-live="polite">
            <h2 className="text-2xl uppercase font-bold">Category Not Found</h2>
            <Link to={"/"} replace aria-label="Go to home page">
              <Button aria-label="Go To Home">Go To Home!</Button>
            </Link>
          </div>
        )}
      </Container>
    </div>
  );
}

export default Single;